exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__user-card-stats___2q1wZ{display:flex;flex-flow:row;justify-content:center;font-size:.75rem}.styles__stat-container___LCPe0{border-top:2px solid hsla(184,6%,53%,.2);border-right:2px solid hsla(184,6%,53%,.2);min-width:4rem;padding:.25rem}.styles__stat-container___LCPe0:last-child{border-right:none}.styles__stat-name___2COsF{display:flex;flex-flow:row;justify-content:center;color:#7f8c8d}.styles__stat-value___vSJHA{display:flex;flex-flow:row;justify-content:center;color:#2c3e50;font-weight:700}", ""]);

// exports
exports.locals = {
	"user-card-stats": "styles__user-card-stats___2q1wZ",
	"stat-container": "styles__stat-container___LCPe0",
	"stat-name": "styles__stat-name___2COsF",
	"stat-value": "styles__stat-value___vSJHA"
};